<template>
    <div>
      <div class="header-width divcss5">
         <productdetailbanner></productdetailbanner>
      </div>
      <div class=" row body-width divcss5">
        <producthsvr></producthsvr>
      </div>
    </div>
</template>
<script>
  import productdetailbanner from "@/components//contentcoms/prodecutcontentcoms/productdetailbanner";
  import productheader from "@/components/contentcoms/prodecutcontentcoms/productheader";
  import producthsvr from "@/components/contentcoms/prodecutcontentcoms/hsvrxlcp/producthsvr";
  export default {
    name: "aboutcontent",
    components: {
      productdetailbanner,
      productheader,
      producthsvr
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/productvr.vue